$(function () {
    $('#addregister').on('show.bs.modal', function () {
        var modal       = $(this);
        var upload_form = $(modal).find('form');
        $(upload_form).validate({
            ignore: ':hidden, [contenteditable="true"]',
            debug: false,
            errorClass: 'danger',
            rules: {
                registerfile: { required: true },
            },
            submitHandler: function (form) {
                $('.close').hide();
                $('#cancelregister').prop('disabled', true);
                $('#saveregister').prop('disabled', true).html('Uploading Register ..... <i class="' + FontAwesome.prefix('solid', 'arrows-rotate', true) + '"></i>');
                form.submit();
            },
        });
    });

    if ($('input[name=editMode]').val() != true) {
        $('#attendanceRegisterForm :input').prop('disabled', true);
    }

    $('.noRegisterTaken').click(function () {
        if (confirm('Are you sure you want to mark this event as No Register Taken?')) {
            $(this).prop('disabled', true).html('<i class="' + FontAwesome.prefix('solid', 'spinner', true) + '"></i> Saving Register as Not Taken...');
        } else {
            return false;
        }
    });
});
